module.exports = __webpack_public_path__ + "static/media/en.edc9d2bf.png";